/**
 * MatchStackCard - Stacked card showing grouped photos for a match
 *
 * Features:
 * - 3 offset layers showing photo depth
 * - Match info (teams, time, photo count)
 * - LIVE indicator with pulsing animation
 * - Click to expand
 */
import styles from './MatchStackCard.module.css';

export default function MatchStackCard({
  match,
  photoCount,
  statusCounts = {},
  isLive = false,
  isUnassigned = false,
  onClick,
  previewUrls = [],
}) {
  const title = isUnassigned
    ? 'Unassigned'
    : match
    ? `${match.home_team_name} vs ${match.away_team_name}`
    : 'Unknown Match';

  const subtitle = isUnassigned
    ? 'Photos not linked to any match'
    : match?.venue || '';

  return (
    <button className={`${styles.stackCard} ${isUnassigned ? styles.unassigned : ''}`} onClick={onClick} type="button">
      {/* Stacked layers effect */}
      <div className={styles.stackLayers}>
        {[2, 1, 0].map((layer) => (
          <div
            key={layer}
            className={styles.layer}
            style={{
              '--layer-offset': `${layer * 4}px`,
              backgroundImage: previewUrls[layer] ? `url(${previewUrls[layer]})` : undefined,
            }}
          />
        ))}
      </div>

      {/* Content overlay */}
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
          {isLive && <span className={styles.liveBadge}>LIVE</span>}
        </div>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        <div className={styles.stats}>
          <span className={styles.photoCount}>{photoCount} photos</span>
          {statusCounts.pending > 0 && (
            <span className={styles.statusBadge}>{statusCounts.pending} pending</span>
          )}
          {statusCounts.done > 0 && (
            <span className={`${styles.statusBadge} ${styles.done}`}>{statusCounts.done} done</span>
          )}
        </div>
      </div>
    </button>
  );
}
